var loader = require('./dist/featureInstancesModule');

module.exports = loader;